import ExpandArrowsIcon from '~/components/Icons/svgs/ExpandArrowsIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { Breakpoint, useBreakpoint } from '~/utils'

export default function ExpandButton({ disabled }: { disabled?: boolean }) {
  const br = useBreakpoint()
  const size = br < Breakpoint.MD ? 12 : 18

  return (
    <div
      className={`flex items-center justify-center bg-purple text-2.5 w-full p-0.5 rounded ${
        !disabled ? 'hover:bg-purple-gmedium-dark' : ''
      }`}
    >
      <SVGIcon icon={ExpandArrowsIcon} pathClassName="bg-white" size={size} />
    </div>
  )
}
